import { Component, input, contentChild, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-card',
    imports: [CommonModule],
    host: {
        class: 'block',
        '[class]': 'hostClass()'
    },
    template: `
        <div class="bg-white rounded-xl shadow-sm border border-gray-100 p-4 hover:shadow-md transition-shadow h-full overflow-hidden min-w-0 flex flex-col">
            @if (icon() || title()) {
                <div class="flex items-center gap-2 mb-4 shrink-0">
                    @if (icon()) {
                        <div [class]="getIconContainerClasses()">
                            <span class="material-icons-outlined text-white text-lg">{{ icon() }}</span>
                        </div>
                    }
                    @if (title()) {
                        <div>
                            <h3 class="text-lg font-semibold text-gray-900">{{ title() }}</h3>
                            @if (subtitle()) {
                                <p class="text-xs text-gray-400">{{ subtitle() }}</p>
                            }
                        </div>
                    }
                    @if (headerTemplate()) {
                        <ng-container *ngTemplateOutlet="headerTemplate()!"></ng-container>
                    }
                </div>
            }
            <div class="flex-1 min-h-0">
                <ng-content></ng-content>
            </div>
        </div>
    `
})
export class CardComponent {
    icon = input<string>('');
    title = input<string>('');
    subtitle = input<string>('');
    iconGradient = input<string>('from-blue-500 to-blue-600');
    hostClass = input<string>('');
    headerTemplate = contentChild('headerTemplate', { read: TemplateRef });

    getIconContainerClasses(): string {
        const baseClasses = 'w-8 h-8 rounded-lg bg-gradient-to-br flex items-center justify-center';
        return `${baseClasses} ${this.iconGradient()}`;
    }
}
